// Styles
import '../../scss/components/forms'

// formulaire de tri ou du nombre d'éléments affichables
document.querySelectorAll('form[name="mdForm"]').forEach(el => {
  el.querySelectorAll('select').forEach(selEl => {
    selEl.addEventListener('change', () => {
      el.submit()
    })
  })
})
